import React, { Component } from "react"
import { PropTypes } from "prop-types"
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';
import { Row,Col,Button,FormGroup,FormControl,InputGroup } from "react-bootstrap"
import { orange } from '../../../utils/constants'
import { getActiveSeasons } from '../../../components/common/api'
import { fetchingEventDirectorEvents, fetchEventDirectorEvents } from '../../../redux/actions/action_managefunds';

const formName = 'managefunds'

export const SearchBy = {
	Director: 'email',
	DirectorName: "dirname",
	Membership: 'membership'
}

const SearchByDescription = {
	Director: "Director's email",
	DirectorName: "Director's name",
	Membership: "Director's member Id"
}

class SearchBar extends Component { 
	constructor(props)
  {
    super(props)   
    this.state = { 
			seasonId:'',
			searchBy: SearchBy.DirectorName,
			searchValue:'',
			seasons:[],
		}
		this.handleSearch = this.handleSearch.bind(this)
		this.handleSearchByChange = this.handleSearchByChange.bind(this)
		this.setSearchTextField = this.setSearchTextField.bind(this)
		this.setModes = this.setModes.bind(this)
		this.setSeasons = this.setSeasons.bind(this)
		this.handleSearchSeasonChange = this.handleSearchSeasonChange.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)
		this.setSearchByOptions = this.setSearchByOptions.bind(this)
	}
	
	componentDidMount()	{
		const _this = this;
		getActiveSeasons().then(function(response) {
			_this.setState({ 
				seasons: response.data,
				seasonId: response.data[0].id
			})
		})
	}

	handleSearchSeasonChange = (event) => {
		const season = event.target.value
		
		this.setState({
			seasonId:season
		})
	}

	handleSearch()
    {
        const {
            searchBy,
            searchValue,
            seasonId
		} = this.state
		
		const { dispatch, onSearch } = this.props;

		dispatch(fetchingEventDirectorEvents());
		dispatch(fetchEventDirectorEvents(seasonId, searchBy, searchValue));
		onSearch();
    }

	handleSearchByChange = (event) => {
		const searchby = event.target.value
		const freetextsearch = true
		this.setModes(freetextsearch,searchby,'')
	}

    handleValueChange(evt) {
		const searchValue = evt.target.value;
        this.setState({ searchValue: searchValue });
    }
	
    setSearchTextField = () => {
	const fldtype = 'text'
	return (<FormControl type={fldtype} placeholder={this.state.searchBy === SearchBy.Membership ? 'xxxxx-xxxxxxx' : this.state.searchBy === SearchBy.DirectorName ? 'Enter first or last name' : 'Enter value'} style={{ minWidth:'270px' }} value={this.state.searchValue} onChange={this.handleValueChange}/>)
    }

	setModes = (freetextsearch=null,searchby=null,searchValue='') => {
		this.setState({
			freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
			searchBy: searchby !== null ? searchby : this.state.searchBy,
			searchValue
		})
    }
    
	setSeasons()
	{	
		const { seasons } = this.state;
		const seasonsArray = Object.values(seasons)
		const option = seasonsArray.map((season) => {
		return (<option key={season.id} value={season.id}>{season.description}</option>)
		})
		return option
	}

	setSearchByOptions = () => {
		
		const { SearchByOptions } = this.props

		return ([
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.DirectorName) : true) && <option value={SearchBy.DirectorName} key='1'>{ SearchByDescription.DirectorName }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Membership) : true)  && <option value={SearchBy.Membership} key='4'>{ SearchByDescription.Membership }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Director) : true)  && <option value={SearchBy.Director} key='6'>{ SearchByDescription.Director }</option>
		])
	}

	render()
	{
		const {
			searchValue, 
			seasons
		} = this.state;

		const {	searchMode } = this.props;

		const activeSeasons = (_.find(seasons,{ isSeasonSet: true }) !== undefined);

	return (<Row>
		<Col xs={12}>
			<div className="stacked-filter-panel">
				<FormGroup controlId="searchby" className="searchby-filter">
					<FormControl  componentClass="select" onChange = { this.handleSearchSeasonChange } style={{ minWidth:'120px',borderRadius:'0' }}>
						{
							this.setSeasons() 
						}
					</FormControl>
					<FormControl defaultValue={SearchBy.DirectorName} componentClass="select" onChange = { this.handleSearchByChange } style={{ minWidth:'180px',borderRadius:'0' }}>
						{
							this.setSearchByOptions()
						}
					</FormControl>
					<InputGroup>
						{
							this.setSearchTextField()
						}
						<InputGroup.Button>
							<Button onClick={ this.handleSearch } style={{ color:orange, marginLeft:'0px', minHeight:'34px' }} disabled={ searchValue.length < 3 || !activeSeasons }>
								<i className={ searchMode === true ? "fa fa-spinner fa-spin":"fa fa-search"} aria-hidden="true"  />
							</Button>
						</InputGroup.Button>
					</InputGroup>
				</FormGroup>
			</div>
		</Col>
	</Row>)
	}
}

SearchBar.propTypes = {
	dispatch: PropTypes.func,
	SearchByOptions:PropTypes.array,
	searchMode: PropTypes.bool,
	onSearch: PropTypes.func
}

function mapStateToProps(state,ownProps){
	const formName          =  ownProps.form;
	const selector          = formValueSelector(formName);
	const savingTransfer    = selector(state, 'savingTransfer');
	const searchMode		= selector(state, 'searchMode');
	return {
		savingTransfer,
		searchMode
	};
  }
  function mapDispatchToProps(dispatch){
	return bindActionCreators({
		fetchingEventDirectorEvents,
		fetchEventDirectorEvents
		},dispatch)
  }
  export default reduxForm({
	form:formName,
	destroyOnUnmount: false
  })(connect(mapStateToProps,mapDispatchToProps)(SearchBar))


// WEBPACK FOOTER //
// ./src/containers/deposit/components/searchbar.js